export const setupCSRFProtection = () => {
  const token = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
  
  if (token) {
    // Override fetch to include CSRF token for same-origin requests
    const originalFetch = window.fetch
    
    window.fetch = function(url, options = {}) {
      // Only add CSRF token for same-origin requests
      if (typeof url === 'string' && (url.startsWith('/') || url.startsWith(window.location.origin))) {
        options.headers = options.headers || {}
        options.headers['X-CSRF-Token'] = token
      }
      
      return originalFetch.call(this, url, options)
    }
  }
}
